// @ts-nocheck

import React, { useState, useCallback, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useLongPress } from 'use-long-press';

import theme from '../../styled-components/dark';

const fill = keyframes`
  from {
    background-position: right bottom;
  }

  to {
    background-position: left bottom;
  }
  `;

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5em;
  border: none;
  height: 2.5em;
  padding: 0 1em;
  user-select: none;
  cursor: pointer;
  color: ${theme.LongPressButton.default.color};
  background: ${theme.LongPressButton.default.backgroundColor};
  /* Old browsers */
  background: linear-gradient(
    to right,
    ${theme.LongPressButton.default.fillBackgroundColor} 49%,
    ${theme.LongPressButton.default.backgroundColor} 50%
  );
  background-size: 200% 100%;
  background-position: right bottom;

  ${({ $pressing, $threshold }) =>
    $pressing
      ? css`
          animation: ${fill} ${$threshold}ms ease-in-out;
        `
      : ''}
`;

type LongPressButtonProps = {
  className?: string;
  children: Array<Node>;
  threshold: number;
  onPress: (...params: unknown) => unknown;
};

const LongPressButton = ({ className, onPress, threshold = 500, children }): LongPressButtonProps => {
  const [pressing, setPressing] = useState(false);

  const callback = useCallback(() => {
    setPressing(false);
    if (onPress) {
      onPress();
    }
  }, [onPress]);

  const preventContextMenu = useCallback((e) => {
    e.preventDefault();
    return false;
  }, []);

  useEffect(() => {
    if (pressing) {
      document.addEventListener('contextmenu', preventContextMenu);
    } else {
      document.removeEventListener('contextmenu', preventContextMenu);
    }
  }, [pressing, preventContextMenu]);

  const bind = useLongPress(callback, {
    onStart: () => setPressing(true),
    onCancel: () => setPressing(false),
    filterEvents: (event) => ('button' in event ? event.button === 0 : true),
    threshold,
    captureEvent: true,
    cancelOnMovement: false,
    detect: 'both',
  });

  return (
    <StyledButton className={className} $pressing={pressing} $threshold={threshold} {...bind}>
      {children}
    </StyledButton>
  );
};

export default LongPressButton;
